module.exports = __webpack_public_path__ + "img/orange_028.25619cf0.png";